const ReactRailsUJS = require("react_ujs");

require("url-search-params-polyfill");
const Cookies = require("js-cookie");

// Copied from https://github.com/reactjs/react-rails/issues/264#issuecomment-552326663
// This provides better error messages for when server side rendering fails
// TODO: Add correct types
function fromRequireContext(reqctx: any) {
  return function (className: any) {
    const parts = className.split(".");
    const filename = parts.shift();
    const keys = parts;
    // Load the module:
    let component = reqctx("./" + filename);
    // Then access each key:
    keys.forEach((k: any) => {
      component = component[k];
    });
    // support `export default`
    if (component.__esModule) {
      component = component.default;
    }
    return component;
  };
}
ReactRailsUJS.getConstructor = fromRequireContext(
  require.context("pages/landing", true, /^(\.\/)?[^.]+$/),
);

(function () {
  if (Cookies.get("stotles_utm")) {
    return;
  }

  if (typeof window === "undefined") {
    return;
  }

  type VisitInfo = {
    referrer: string;
    url: string;
    // TODO: type this when https://github.com/Stotles/stotles/pull/4128 and
    // https://github.com/Stotles/stotles/pull/4135 are merged
    utmParams: any;
  };

  const params = new URLSearchParams(window.location.search);
  const referrer = document.referrer;
  const visitInfo: VisitInfo = {
    referrer: referrer,
    url: location.href,
    utmParams: {},
  };

  params.forEach((v, k) => {
    const match = k.match(/utm_(.+)/);
    if (!match || !match[1]) {
      return;
    }
    visitInfo.utmParams[match[1]] = v;
  });

  Cookies.set("stotles_utm", visitInfo, { domain: "stotles.com" });
})();

export {};
